import { en } from "./en";
import { nl } from "./nl";

const languages = { nl, en };
export const dictionary =
  languages[process.env.REACT_APP_LANGUAGE as "nl" | "en"] ?? en;
